{
  "navigation": {
    "dashboard": "الرئيسية"
  },
  "user": {
    "notifications": "الإشعارات"
  }
}
